var _defs, _rect, _path, _path2, _polyline, _polyline2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _rect2, _ellipse2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChinacollar01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-47,.cls-45,.cls-44,.cls-40,.cls-39{fill:#fff;}.cls-46,.cls-43,.cls-42,.cls-41{fill:none;}.cls-46,.cls-45,.cls-44,.cls-43,.cls-42,.cls-41{stroke:#000;}.cls-46,.cls-45,.cls-44,.cls-43,.cls-42,.cls-41,.cls-40,.cls-39{stroke-miterlimit:10;}.cls-46,.cls-45{stroke-width:2px;}.cls-44{stroke-dasharray:3;}.cls-43,.cls-42,.cls-41{stroke-width:0.75px;}.cls-42{stroke-dasharray:2.99 2.99;}.cls-41{stroke-dasharray:2.97 2.97;}.cls-40,.cls-39{stroke:#010101;}.cls-40{stroke-width:2.7px;}.cls-39{stroke-dasharray:2.7;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 192.02,
    y: 232.06,
    width: 38.22,
    height: 55.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M309.5,189.87v2.24a57.84,57.84,0,0,1-6.84,11c-17,21.81-51.1,36.69-90.37,36.69h0a16.19,16.19,0,0,0-5.37.91c-37-1.29-68.74-15.79-85-36.59a57.9,57.9,0,0,1-7.09-11.55s0,0,0,0c-.24-.52-.47-1-.68-1.57V188c.21.52-.12-.53.12,0,0,0,0-.47,0-.47l.41,0c11.68-26,43.68-38.9,96.46-38.9C256.73,148.61,296.49,169.22,309.5,189.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M372.78,228l-3.66,170.89H54.45L50.88,228.55l59.19-21.41c2.23,7.18,5.42,16.32,8.77,22.07,17,29.35,54.88,37,76.63,38.93,4.88.44,8.95.59,11.79.63h.4c1,0,1.85,0,2.5,0h.38l1.1,0h.29l1.1,0h.4c2.11,0,6.29,0,11.79-.39.92-.07,1.88-.14,2.88-.24,21.74-1.93,59.64-9.58,76.63-38.93,3.45-5.94,6.92-16,9.21-23.37Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-46",
    points: "50.23 228.33 53.8 227.03 109.42 206.86 112.98 205.56"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-46",
    points: "372.13 227.8 368.46 226.42 313.29 205.62 311.11 204.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M189.91,235.64h0a16.27,16.27,0,0,1,16.28,16.27l1.17,20.87c-.67,0-16.82-.89-17.5-1-38.67-3.93-52-12.06-69-33.87-7.38-9.45-11.55-20.19-11.55-31.59V170.69c0,1,0,1.93.1,2.89a0,0,0,0,0,0,0,48.27,48.27,0,0,0,4.35,17.09s0,0,0,0a58.72,58.72,0,0,0,7.09,11.56C137.84,224.08,149.66,229.67,189.91,235.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M204.2,269.62c-4.77-.25-13.24-.72-14-.79C152,265,139.43,256.88,123.22,236.11c-7.24-9.28-10.91-19.28-10.91-29.75V194.55a62.54,62.54,0,0,0,6.18,9.57c17.36,22.28,30,28.4,71,34.48l.22,0H190a13.29,13.29,0,0,1,13.24,13.27v.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M232.36,235.94h0a16.27,16.27,0,0,0-16.28,16.27l-1.17,20.87c.67,0,16.82-.89,17.5-1,38.67-3.93,52-12.06,69-33.87,7.38-9.45,11.54-20.19,11.54-31.59V171c0,1,0,1.93-.1,2.89a0,0,0,0,1,0,0A47.85,47.85,0,0,1,308.5,191s0,0,0,0a58.67,58.67,0,0,1-7.08,11.56C284.42,224.38,272.6,230,232.36,235.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M219.05,252.3v-.09a13.29,13.29,0,0,1,13.23-13.27h.28l.22,0c41-6.09,53.64-12.21,71-34.49a61.8,61.8,0,0,0,6.18-9.57v11.81c0,10.47-3.67,20.47-10.91,29.74-16.2,20.78-28.75,28.85-67,32.73-.77.07-9.24.54-14,.79Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M313,169.85a0,0,0,0,1,0,0A48.27,48.27,0,0,1,308.6,187s0,0,0,0l-.18.4c-12.95-20.7-51.6-35.72-97.27-35.72s-84.31,15-97.27,35.72l-.18-.4s0,0,0,0a47.85,47.85,0,0,1-4.35-17.09,0,0,0,0,1,0,0c2.3-27.12,47-48.76,101.81-48.76S310.64,142.73,313,169.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M307.63,181.13c-16.29-19.64-53.94-32.52-96.5-32.52s-80.2,12.88-96.5,32.52a44.69,44.69,0,0,1-2.25-11.23c2.38-25.25,46.59-45.75,98.75-45.75s96.37,20.5,98.75,45.75A44.25,44.25,0,0,1,307.63,181.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M308.09,179.7c-.15.48-.3,1-.46,1.43l-1-1.14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M304.61,177.81c-17.61-17.76-53.37-29.2-93.48-29.2-40.91,0-77.29,11.9-94.51,30.27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M115.61,180l-1,1.14c-.16-.47-.31-.95-.45-1.43"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M113.41,176.83a44.24,44.24,0,0,1-1-6.93c2.38-25.25,46.59-45.75,98.75-45.75s96.37,20.5,98.75,45.75a43.67,43.67,0,0,1-1.39,8.37"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M194.33,398.69l0-3,.88-119,0-2.75c6.74.6,11.89.63,14.28.6h.39l1.07,0h.29l1.07,0h.37c.63,0,1.45,0,2.43,0h.39c2.77,0,6.73-.18,11.48-.6v.23l0,3,.88,118.49,0,3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M197.35,395.69l.87-118.48c4.34.3,7.86.37,10.22.37,1.32,0,2.19,0,2.5,0h.33c.36,0,1.23,0,2.55,0,2.36,0,5.88-.07,10.22-.37l.87,118.48"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.13,
    cy: 292.96,
    rx: 6.71,
    ry: 6.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.44,
    y: 284.25,
    width: 1.39,
    height: 17.84
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.13,
    cy: 376.96,
    rx: 6.71,
    ry: 6.41
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210.44,
    y: 368.25,
    width: 1.39,
    height: 17.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinacollar01);
export default __webpack_public_path__ + "static/media/CHINA COLLAR-01.8d519d0361926b0a439958e7a7618341.svg";
export { ForwardRef as ReactComponent };